import type { GenerationOptions, GenerationResponse } from './types';

// ========== TEXT TO VIDEO GENERATORS ==========

export const generateText2VideoVeo3 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'fal_ai',
    modelId: 'veo3',
    generationType: 'video'
  });
};

export const generateText2VideoVeo3Direct = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'google',
    modelId: 'veo3',
    generationType: 'video'
  });
};

export const generateText2VideoHailuo02 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'hailuoai',
    modelId: 'hailuo-02',
    generationType: 'video'
  });
};

export const generateText2VideoT2V01Director = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'hailuoai',
    modelId: 't2v-01-director',
    generationType: 'video'
  });
};

export const generateText2VideoS2V01 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'hailuoai',
    modelId: 's2v-01',
    generationType: 'video'
  });
};

// ========== IMAGE TO VIDEO GENERATORS ==========

export const generateImage2VideoKling = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'fal_ai',
    modelId: 'kling-video',
    generationType: 'video'
  });
};

export const generateImage2VideoVeo3Direct = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'google',
    modelId: 'veo3',
    generationType: 'video'
  });
};

export const generateImage2VideoMiniMaxHailuo02I2V = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'fal_ai',
    modelId: 'minimax-hailuo-02-i2v',
    generationType: 'video'
  });
};

export const generateImage2VideoMiniMaxHailuo02FastI2V = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'fal_ai',
    modelId: 'minimax-hailuo-02-fast-i2v',
    generationType: 'video'
  });
};

export const generateImage2VideoHailuo02 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'hailuoai',
    modelId: 'hailuo-02',
    generationType: 'video'
  });
};

export const generateImage2VideoI2V01Director = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'hailuoai',
    modelId: 'i2v-01-director',
    generationType: 'video'
  });
};

export const generateImage2VideoS2V01 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'hailuoai',
    modelId: 's2v-01',
    generationType: 'video'
  });
};

// ========== SORA VIDEO GENERATORS ==========

export const generateText2VideoSora2Pro = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'openai',
    modelId: 'sora-2-pro-1.0',
    generationType: 'video'
  });
};

export const generateText2VideoSora2 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'openai',
    modelId: 'sora-2-1.0',
    generationType: 'video'
  });
};

export const generateText2VideoSora1 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'openai',
    modelId: 'sora-1',
    generationType: 'video'
  });
};

export const generateText2VideoSoraTurbo = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'openai',
    modelId: 'sora-turbo',
    generationType: 'video'
  });
};

export const generateImage2VideoSora2Pro = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'openai',
    modelId: 'sora-2-pro-1.0',
    generationType: 'video'
  });
};

export const generateImage2VideoSora2 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'openai',
    modelId: 'sora-2-1.0',
    generationType: 'video'
  });
};

export const generateImage2VideoSora1 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'openai',
    modelId: 'sora-1',
    generationType: 'video'
  });
};

export const generateImage2VideoSoraTurbo = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'openai',
    modelId: 'sora-turbo',
    generationType: 'video'
  });
};

// ========== BYTEPLUS VIDEO GENERATORS ==========

export const generateText2VideoSeedance = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'byteplus',
    modelId: 'seedance-1.0-pro',
    generationType: 'video'
  });
};

export const generateImage2VideoSeedance = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'byteplus',
    modelId: 'seedance-1.0-pro',
    generationType: 'video'
  });
};

// ========== HAILUOAI DIRECT API GENERATORS ==========

export const generateText2VideoHailuoAI = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'hailuoai',
    modelId: 'MiniMax-Hailuo-02',
    generationType: 'video'
  });
};

export const generateImage2VideoHailuoAI = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'hailuoai',
    modelId: 'MiniMax-Hailuo-02',
    generationType: 'video'
  });
};

// ========== MORPHING VIDEO GENERATORS ==========

export const generateMorphingHailuoAI = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    firstFrameFiles: options.firstFrameFiles,
    lastFrameFiles: options.lastFrameFiles,
    aiProvider: 'hailuoai',
    modelId: 'MiniMax-Hailuo-02',
    generationType: 'video'
  });
};